import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUIStore = create(
  persist(
    (set, get) => ({
      darkMode: false,
      compactMode: true,
      sidebarCollapsed: false,
      mobileMenuOpen: false,

      toggleDarkMode: () => set((state) => {
        const newVal = !state.darkMode;
        document.documentElement.classList.toggle('dark', newVal);
        return { darkMode: newVal };
      }),

      setDarkMode: (val) => {
        document.documentElement.classList.toggle('dark', val);
        set({ darkMode: val });
      },

      // iter938 — Global Compact View. Mirrors darkMode: toggles a `compact`
      // class on <html> so a single global CSS rule tightens every table
      // system-wide. Persisted (see partialize) so it survives navigation.
      toggleCompact: () => set((state) => {
        const newVal = !state.compactMode;
        document.documentElement.classList.toggle('compact', newVal);
        return { compactMode: newVal };
      }),

      setCompact: (val) => {
        document.documentElement.classList.toggle('compact', val);
        set({ compactMode: val });
      },

      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (val) => set({ sidebarCollapsed: val }),
      setMobileMenuOpen: (val) => set({ mobileMenuOpen: val }),

      // Hydrate dark mode from persisted state on app load
      hydrateDarkMode: () => {
        const { darkMode } = get();
        document.documentElement.classList.toggle('dark', darkMode);
      },
    }),
    {
      name: 'ssc-ui',
      partialize: (state) => ({ darkMode: state.darkMode, compactMode: state.compactMode, sidebarCollapsed: state.sidebarCollapsed }),
      onRehydrateStorage: () => (state) => {
        // Apply persisted dark + compact classes when state rehydrates.
        if (state?.darkMode) document.documentElement.classList.add('dark');
        if (state?.compactMode) document.documentElement.classList.add('compact');
      },
    }
  )
);
